export default __webpack_public_path__ + "static/media/halfleavelogo.82d7e865.svg";